import { render, staticRenderFns } from "./CategoriesCalendar.vue?vue&type=template&id=1708c6cb&scoped=true"
import script from "./CategoriesCalendar.vue?vue&type=script&lang=js"
export * from "./CategoriesCalendar.vue?vue&type=script&lang=js"
import style0 from "./CategoriesCalendar.vue?vue&type=style&index=0&id=1708c6cb&prod&scoped=true&lang=scss"
import style1 from "./CategoriesCalendar.vue?vue&type=style&index=1&id=1708c6cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708c6cb",
  null
  
)

export default component.exports